// 后台地址
let JS_CONTEXT = window.localStorage.getItem('PROTOCOL') + '://' +
  window.localStorage.getItem('IP') + ':' +
  window.localStorage.getItem('PORT') + '/' +
  window.localStorage.getItem('PROJECT')
// 是否开启AES加解密
let ENABLE_AES_CODE = false

let SUCCESS_CODE = 20000
// 是测试环境时的资源内容
let DEBUG_RESOURCES = [
  {
    fid: 1,
    fname: '患者',
    fcode: '001',
    fparendId: 0,
    ftype: 'PAGE',
    furl: '/business/patient',
    forder: 0,
    ficon: 'patient-info',
    fchildren: []
  },
  {
    fid: 2,
    fname: '查询',
    fcode: '002',
    fparendId: 0,
    ftype: 'PAGE',
    furl: '/business/search',
    forder: 0,
    ficon: 'search',
    fchildren: []
  },
  {
    fid: 3,
    fname: '数据统计',
    fcode: '003',
    fparendId: 0,
    ftype: 'PAGE',
    furl: '/business/statistics',
    forder: 0,
    ficon: 'statistics',
    fchildren: []
  }
]
let DEBUG_COLUMN_AUTHORITY = [
  {fcolumn_id: 1, ftype: 0},
  {fcolumn_id: 2, ftype: 0},
  {fcolumn_id: 3, ftype: 0},
  {fcolumn_id: 4, ftype: 0},
  {fcolumn_id: 5, ftype: 0},
  {fcolumn_id: 6, ftype: 2},
  {fcolumn_id: 7, ftype: 2},
  {fcolumn_id: 8, ftype: 2}
]

export default {
  JS_CONTEXT: JS_CONTEXT,
  ENABLE_AES_CODE: ENABLE_AES_CODE,
  SUCCESS_CODE: SUCCESS_CODE,
  DEBUG_RESOURCES: DEBUG_RESOURCES,
  DEBUG_COLUMN_AUTHORITY: DEBUG_COLUMN_AUTHORITY
}



// WEBPACK FOOTER //
// ./src/util/constants.js